import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import qs from "query-string";

import { requireLogin } from "../../../security";
import { createProduct } from "../../../product";
import { trackStartProduct } from "../../../analytics";
import { userProductsQueryOptions, useSaveProductMutation } from "../../../data/queries/products";
import { useUser } from "../../../data/context/auth-context";
import { CenteredModal, Spinner } from "../../../ui";
import type { Product } from "../../../data/api/products";

function StartProduct() {
  const { name } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUser();
  const { refetch } = useQuery(
    userProductsQueryOptions({
      userId: user?.uid || "",
      status: "draft",
      name,
    }),
  );
  const saveProductMutation = useSaveProductMutation();

  const createDraftAndRedirect = () => {
    if (!user || !name) return;

    // Create a new Draft if there's no existing draft
    const createdProduct = createProduct(name);
    const product: Product = {
      ...createdProduct,
      userId: user.uid,
      createdAt: null,
      updatedAt: null,
    };
    saveProductMutation.mutate(
      { product, userId: user.uid },
      {
        onSuccess: () => {
          trackStartProduct(name);
          navigate("/upload/" + product.uid, { replace: true });
        },
      },
    );
  };

  useEffect(() => {
    const query = qs.parse(location.search);

    // Create a new draft if forceNew
    if (query.forceNew) {
      createDraftAndRedirect();
      return;
    }

    // Check existing drafts if forceNew is false
    refetch().then((result) => {
      // Use the actual fetched data, not the stale state
      const fetchedProducts = result.data || [];
      if (fetchedProducts.length !== 0) {
        navigate("/account/" + name, { replace: true });
      } else {
        createDraftAndRedirect();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CenteredModal>
      <Spinner />
    </CenteredModal>
  );
}

export default requireLogin()(StartProduct);
